export default {"src":"/_next/static/media/close_gray.99cbcab8.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};